import React from "react";

export const expandIcon = (
  <svg
    width="14"
    height="14"
    viewBox="0 0 14 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12.9656 5.59649H13.6673V12.614C13.6598 13.1922 13.1929 13.6591 12.6147 13.6667H5.59714V12.9649C5.59714 12.1898 6.22551 11.5614 7.00065 11.5614H10.1305L2.43925 3.87018V7C2.43925 7.77514 1.81088 8.40351 1.03574 8.40351H0.333984V1.38597C0.341543 0.807775 0.808424 0.340895 1.38662 0.333336H8.40416V1.03509C8.40416 1.81023 7.77579 2.4386 7.00065 2.4386H3.99714L11.5621 10.0035V7C11.5621 6.22487 12.1904 5.59649 12.9656 5.59649Z"
      fill="white"
    />
  </svg>
);
